export default __webpack_public_path__ + "static/media/kw.11d1af06.svg";